import {
  ChakraBox,
  ChakraFlex,
  ChakraText,
  EquipUITheme,
} from '@equip.health/ui';
import TitleAndValue from '~/components/common/TitleAndValue';
import { isPastDateTime } from '~/lib/util/classes/groupClasses.util';
import { getPreferredFullName } from '~/lib/util/patient.util';

const { label } = EquipUITheme.typography;

type Props = {
  noteExternalId: string;
  groupClassEventDetails?: GroupClassEventDetails;
  confirmedAttendees?: GroupClassEventAttendee[];
};

const groupClassAttendeesToPreferredNameList = (
  attendees: GroupClassEventAttendee[],
): string | undefined => {
  return attendees
    ?.map(({ chosenName, firstName, lastName }) =>
      getPreferredFullName(chosenName, firstName, lastName),
    )
    ?.join(', ');
};

export const PatientNoteItemGroupNoteAttendeesSection = ({
  groupClassEventDetails,
  noteExternalId,
  confirmedAttendees,
}: Props) => {
  const TOP_LEVEL_ID = `patient-note-item__${noteExternalId}`;

  const hasEventEnded =
    !!groupClassEventDetails?.endTime &&
    isPastDateTime(groupClassEventDetails.endTime);

  const attendees: GroupClassEventAttendee[] = [];
  let nonAttendees: GroupClassEventAttendee[] = [];
  confirmedAttendees?.forEach((eachAttendee) => {
    if (eachAttendee.attended || !hasEventEnded) {
      attendees.push(eachAttendee);
    } else {
      nonAttendees.push(eachAttendee);
    }
  });

  if (groupClassEventDetails?.declinedUsers) {
    nonAttendees = nonAttendees.concat(groupClassEventDetails?.declinedUsers);
  }

  return (
    <ChakraFlex alignItems="flex-start" alignSelf="stretch" marginBottom="8px">
      <ChakraBox flexBasis="32%">
        <TitleAndValue
          title="Hosts"
          value={groupClassAttendeesToPreferredNameList(
            groupClassEventDetails?.hosts,
          )}
        />
      </ChakraBox>
      <ChakraBox flexBasis="68%" marginLeft="24px">
        <TitleAndValue
          title="Attendees"
          value={groupClassAttendeesToPreferredNameList(attendees)}
        />
        <ChakraText
          {...label}
          color="neutral.primary"
          fontWeight="500"
          id={`${TOP_LEVEL_ID}__declined-users`}
          textDecoration="line-through"
        >
          {groupClassAttendeesToPreferredNameList(nonAttendees)}
        </ChakraText>
      </ChakraBox>
    </ChakraFlex>
  );
};
